module.exports = __webpack_public_path__ + "static/media/home-icon-home.564e03da.svg";